import { useMutation } from "@apollo/client";
import {
  DELETE_TRANSFER_REQUEST,
  GET_TRANSFER_REQUESTS_BY_PLAYER_ACCEPTED_OR_TEAM_ACCEPTED,
  GET_TRANSFER_REQUESTS_BY_PLAYER_ACCEPTED_AND_TEAM_ACCEPTED,
  TRANSFER_REQUESTS_WITH_PERMISSION,
} from "../../GraphQL/TransferRequests";
import useNotification from "../../hooks/useNotification.js";
import ConfirmDeleteDialog from "../UI/ConfirmDeleteDialog.js";

const DeleteTransferRequestDialog = (props) => {
  const { notifySuccess } = useNotification();

  const [deleteTransferRequest, { loading, error }] = useMutation(
    DELETE_TRANSFER_REQUEST,
    {
      variables: { id: props.transferRequest.id },
      refetchQueries: [
        GET_TRANSFER_REQUESTS_BY_PLAYER_ACCEPTED_OR_TEAM_ACCEPTED,
        GET_TRANSFER_REQUESTS_BY_PLAYER_ACCEPTED_AND_TEAM_ACCEPTED,
        TRANSFER_REQUESTS_WITH_PERMISSION,
      ],
      onCompleted: () => {
        notifySuccess("Transfer request deleted.");
        props.setOpen(false);
      },
    }
  );

  return (
    <ConfirmDeleteDialog
      open={props.open}
      setOpen={props.setOpen}
      entityName={`${props.transferRequest.player.name} → ${props.transferRequest.team.name}`}
      onConfirm={deleteTransferRequest}
      loading={loading}
      error={error}
      confirmTestId="deleteDeleteTransferRequestDialogButton"
      cancelTestId="closeDeleteTransferRequestDialogButton"
    />
  );
};

export default DeleteTransferRequestDialog;
